import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import TabsNav from "../../components/TabsNav";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import { BtnGroupStyle, ContentStyle, DataGridListStyle } from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import { DialogPopup } from "../../components/DialogPopup";
import ConfirmPopup from "../../components/ConfirmPopup";
import LockIcon from "@mui/icons-material/Lock";
import { useDispatch, useSelector } from "react-redux";
import { loadingSavedPrescriptions } from "../../Redux/Slice/SavedPrescriptionSlice";
import { v4 as uuid } from "uuid";
import {
  ConfirmSavedPrescriptions,
  RemoveAllPatientSavedPrescriptionsById,
} from "../../Apis/AuthApiServices";
import YSSnackBar from "../../uikit/YSSnackBar";
import NoRecords from "../../components/NoRecords";
import {
  DrugTextNTooltip,
  PharmacyTextNTooltip,
  TextNTooltip,
} from "../../components/Content";
import ErrorOverlay from "../../components/ErrorOverlay";
import { useOnBehalfContext } from "../../context/OnbehalfContext";

export default function SavedPrescriptions() {
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const { onBehalfContext }: any = useOnBehalfContext();

  const [selectionData, setSelectionData] = useState("");
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const navigate = useNavigate();

  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("savedPrescriptionIds", selectionData);
      const result = await RemoveAllPatientSavedPrescriptionsById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        getSavedPrescriptionData(page);
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const columns: GridColDef[] = [
    {
      field: "description",
      headerName: "Drug Description",
      width: 140,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: ({ row }) => (
        <DrugTextNTooltip
          row={row}
          onClick={() => {
            if (UserServiceState?.profileGroup !== 11) {
              navigate("/newrxpad", {
                state: {
                  rowData: row,
                  key: "comingSavedPres",
                },
              });
            }
          }}
          color={UserServiceState?.profileGroup !== 11 ? "primary" : ""}
        />
      ),
    },
    {
      field: "sig",
      headerName: "SIG",
      width: 140,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: (params: any) => <TextNTooltip Text={params.value} />,
    },
    {
      field: "createdDate",
      headerName: "Date",
      width: 80,
      cellClassName: "w10",
      headerClassName: "w10",
    },
    {
      field: "pharmacyName",
      headerName: "Pharmacy",
      width: 140,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: ({ row }) => <PharmacyTextNTooltip row={row} />,
    },
    {
      field: "doctorName",
      headerName: "Physician",
      width: 100,
      cellClassName: "w12",
      headerClassName: "w12",
    },
    {
      field: "formularyStatus",
      headerName: "Fmlry. Status",
      width: 160,
      cellClassName: "w20",
      headerClassName: "w20",
    },
    {
      field: "copay",
      headerName: "Copay",
      width: 100,
      cellClassName: "w15",
      headerClassName: "w15",
    },
  ];
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [deletePharmacyPopup, setDeletePharmacyPopup] = React.useState(false);
  const dispatch = useDispatch();
  const handleShowDeletePopupClick = () => {
    setDeletePharmacyPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeletePharmacyPopup(false);
  };

  const SavedPrescriptionsState = useSelector((state: any) => {
    return { ...state.SavedPrescriptionSlice };
  }); //redux data

  const [rowCountState, setRowCountState] = useState(
    SavedPrescriptionsState?.Pagination?.totalItems || 0
  );
  const [superId, setSuperId] = useState("");
  useEffect(() => {
    const handleStorage = () => {
      const pId: any = localStorage.getItem("SupervisorDoctorId");
      setSuperId(pId);
    };

    window.addEventListener("storage", handleStorage);

    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  const patientId: any = sessionStorage.getItem("patientId");
  const getSavedPrescriptionData = (nextPage: number) => {
    let paramdata = {
      pageNumber: nextPage,
      patientId: patientId,
      doctorId:
        UserServiceState?.profileGroup > 6
          ? localStorage.getItem("SupervisorDoctorId")
          : localStorage.getItem("doctorId"),
    };
    dispatch(loadingSavedPrescriptions(paramdata));
  };
  useEffect(() => {
    getSavedPrescriptionData(page);
  }, [page, patientId, superId]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      SavedPrescriptionsState?.Pagination?.totalItems !== undefined
        ? SavedPrescriptionsState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [SavedPrescriptionsState?.Pagination?.totalItems, setRowCountState]);

  const [load, setLoad] = useState(false);
  const confirmSavedPrescriptions = async () => {
    try {
      setLoad(true);
      const bodyData = {
        patientId: patientId,
        userDetails: {
          doctorId:
            UserServiceState?.profileGroup > 6
              ? localStorage.getItem("SupervisorDoctorId")
              : localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
        prescriptionIds: selectionData === "" ? null : selectionData,
      };
      const result: any = await ConfirmSavedPrescriptions(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        navigate("/newrxpad/summary", { state: "confirmSpList" });

        sessionStorage.setItem(
          "locationData",
          JSON.stringify(result?.data?.response[0])
        );
        sessionStorage.setItem(
          "rxTabs",
          JSON.stringify(result?.data?.response[0]?.prescriptionFormList)
        );
        sessionStorage.setItem(
          "rxTabsErrors",
          JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
        );
        setLoad(false);
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setLoad(false);
      }
    } catch (er) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again Later!",
          variant: "error",
          open: true,
        };
      });
      setLoad(false);
    }
  };
  if (load)
    return (
      <Grid
        container
        justifyContent={"center"}
        display={"flex"}
        alignItems="center"
        height={"100vh"}
      >
        {" "}
        <CircularProgress color="primary" />
      </Grid>
    );
  return (
    <>
      <TabsNav />{" "}
      <ContentStyle>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={SavedPrescriptionsState?.Items ?? []}
                headerHeight={36}
                paginationMode="server"
                sortingOrder={["desc", "asc"]}
                columns={columns}
                autoHeight
                rowHeight={40}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                checkboxSelection
                getRowId={(row) => row.savePersonPrescriptionId ?? uuid()}
                loading={SavedPrescriptionsState?.isLoading}
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={SavedPrescriptionsState?.error || undefined}
                page={page}
                pageSize={pageSize}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                rowCount={rowCountState}
                onSelectionModelChange={(ids: any) => {
                  setSelectionData(ids);
                }}
                getRowClassName={(params) => {
                  if (params.row.obseletRx) {
                    return "OP";
                  }
                  return "";
                }}
              />
            </DataGridListStyle>
          </Grid>
          <Grid item xs={12}>
            <BtnGroupStyle className="middle">
              {" "}
              <YSButton
                onClick={handleShowDeletePopupClick}
                className=""
                children={"Delete"}
                disabled={
                  // localStorage.getItem("onBehalf")
                  onBehalfContext?.id && UserServiceState?.profileGroup !== 11
                    ? false
                    : UserServiceState?.profileGroup > 9
                    ? true
                    : false
                }
                startIcon={
                  // localStorage.getItem("onBehalf")
                  onBehalfContext?.id && UserServiceState?.profileGroup !== 11
                    ? null
                    : UserServiceState?.profileGroup > 9 && <LockIcon />
                }
                size={"large"}
                type="button"
                color="primary"
                variant="outlined"
              />{" "}
              <YSButton
                onClick={() => {
                  confirmSavedPrescriptions();
                }}
                className=""
                disabled={
                  // localStorage.getItem("onBehalf")
                  onBehalfContext?.id && UserServiceState?.profileGroup !== 11
                    ? false
                    : UserServiceState?.profileGroup > 9
                    ? true
                    : false
                }
                startIcon={
                  // localStorage.getItem("onBehalf")
                  onBehalfContext?.id && UserServiceState?.profileGroup !== 11
                    ? null
                    : UserServiceState?.profileGroup > 9 && <LockIcon />
                }
                children={"Confirm Prescription(s)"}
                size={"large"}
                type="button"
                color="primary"
                variant="contained"
              />{" "}
            </BtnGroupStyle>
          </Grid>
        </Grid>{" "}
      </ContentStyle>
      <DialogPopup
        windowsize={"sm"}
        show={deletePharmacyPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
